var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',_vm._g({class:_vm.classes,style:(_vm.rootStyles)},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }